export default __webpack_public_path__ + "static/media/carousel3.e9fc134c.png";